const VARIANTS = [
  {
    title: 'Декоративные',
    desc: 'Узорчатое заполнение с растительными или геометрическими мотивами. Решётка выглядит как элемент декора, а не защиты.',
    specs: 'Эстетика + защита',
    imageUrl: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/dd0bd6211c734eca4284ec01d3d3f69e.jpeg',
  },
  {
    title: 'С коваными элементами',
    desc: 'Художественная ковка с авторским рисунком. Индивидуальный дизайн, премиальный внешний вид и надёжная защита.',
    specs: 'Премиум-исполнение',
    imageUrl: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/28204b7cc915945ee54ea7ba5b2efa5b.jpeg',
  },
  {
    title: 'Классические',
    desc: 'Прямые прутья с рамкой. Простая, надёжная и недорогая конструкция. Защита без лишних деталей, аккуратный внешний вид.',
    specs: 'Базовая защита',
    imageUrl: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/83329aabea5d83ceb8dd22b07bd9fbb4.jpeg',
  },
  {
    title: 'Усиленные',
    desc: 'Утолщённый профиль, усиленное крепление к стене. Для помещений с повышенными требованиями к безопасности.',
    specs: 'Максимальная защита',
    imageUrl: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/ec80224b563489092bcd36951ad09643.jpeg',
  },
  {
    title: 'Распашные',
    desc: 'Створки открываются наружу для мытья окон и экстренного выхода. Полноценная защита без потери функциональности.',
    specs: 'С открыванием',
    imageUrl: 'https://readdy.ai/api/search-image?query=Swing%20open%20window%20security%20grille%20with%20hinged%20panels%20dark%20charcoal%20metal%20frame%20on%20a%20residential%20facade%20daytime%20exterior%20shot%20practical%20design%20showing%20opening%20mechanism%20realistic%20architectural%20photography%20clean%20detail&width=800&height=600&seq=var-wgrille-swing&orientation=landscape',
  },
];

export default function VariantsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Варианты исполнения
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Пять типов решёток — от&nbsp;базовой защиты до&nbsp;премиальной ковки. Подберём под&nbsp;архитектуру и&nbsp;задачи
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {VARIANTS.map((variant, idx) => (
            <div
              key={variant.title}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden transition-all duration-400 hover:border-primary-200/50 flex flex-col animate-fade-in-up"
              style={{ animationDelay: `${idx * 0.08}s` }}
            >
              <div className="relative w-full h-52 md:h-60 overflow-hidden shrink-0">
                <img
                  src={variant.imageUrl}
                  alt={variant.title}
                  className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">{variant.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3 flex-1">{variant.desc}</p>
                <p className="text-xs font-medium text-accent-600 mb-4 bg-accent-100 inline-block self-start px-2.5 py-1 rounded-full">{variant.specs}</p>
                <a
                  href="https://wa.me/79174131562?text=%D0%97%D0%B4%D1%80%D0%B0%D0%B2%D1%81%D1%82%D0%B2%D1%83%D0%B9%D1%82%D0%B5!%20%D0%98%D0%BD%D1%82%D0%B5%D1%80%D0%B5%D1%81%D1%83%D1%8E%D1%82%20%D1%80%D0%B5%D1%88%D1%91%D1%82%D0%BA%D0%B8%20%D0%BD%D0%B0%20%D0%BE%D0%BA%D0%BD%D0%B0."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm px-5 py-2.5 rounded-md transition-all duration-300 cursor-pointer text-center"
                >
                  Узнать стоимость
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}